import { DeletionBanner } from "@/components/deletion-banner";
import { CookieBanner } from "@/site/components/cookie-banner";
import { SiteFooter, SimpleFooter } from "@/site/components/site-footer";
import { SiteHeader } from "@/site/components/site-header";
import { Outlet, useLocation } from "@tanstack/react-router";

type SiteLayoutProps = {
  footer?: "full" | "simple";
};

export function SiteLayout({ footer = "full" }: SiteLayoutProps) {
  // (usePostAuthFunnel moved to __root.tsx 2026-08-18 — see the note there.)
  // Old `showSimpleFooter`: the card send/view surface gets the plain copyright
  // strip instead of the full footer (pairs with the simple header variant).
  const { pathname } = useLocation();
  if (
    pathname.startsWith("/card/send/view/") ||
    pathname.startsWith("/s/") ||
    pathname.startsWith("/dob/")
  )
    footer = "simple";
  return (
    <div className="flex min-h-dvh flex-col">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-9999 focus:px-4 focus:py-2 focus:rounded-md focus:bg-background focus:text-foreground focus:shadow-md focus:ring-2 focus:ring-ring"
      >
        Skip to main content
      </a>
      {/* Nav + footer are omitted from print (old @media print hid header/footer);
          the calendar prints in place via window.print(). */}
      <div className="print:hidden">
        <DeletionBanner />
        <SiteHeader />
      </div>
      {/* `flex-1` lets main grow to fill the viewport (outer is min-h-dvh) so the
          footer rests at the bottom of short pages without pushing below the fold —
          no scroll needed on small content or short viewports.
          `empty:min-h-…`: while a route's lazy chunk is still downloading the Outlet
          renders nothing, so the footer painted in the first viewport and was shoved
          off-screen when the page arrived — CLS 0.2+ on every cold load (Search Console
          mobile CLS 0.22, measured 2026-11-02). An empty main holds the viewport instead. */}
      <main id="main-content" className="flex-1 empty:min-h-[calc(100dvh-65px)]">
        <Outlet />
      </main>
      <div className="print:hidden">{footer === "simple" ? <SimpleFooter /> : <SiteFooter />}</div>
      <CookieBanner />
    </div>
  );
}
